import { Translate } from '@dreryk/react-common';
import { Toggle } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../translations';
import { ReceptionServiceFormController } from '../../ReceptionServiceForm';

type ReceptionServiceFreeToggleProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
   readonly checked: boolean;
};

export const ReceptionServiceFreeToggle = (props: ReceptionServiceFreeToggleProps): JSX.Element => {
   return (
      <Toggle
         testId={'freeChecked'}
         controller={props.register('freeChecked')}
         label={
            props.checked ? receptionServiceTranslationKeys.shared.form.components.freeCheckedToggle.label : undefined
         }
         rightSlot={
            <Translate>{receptionServiceTranslationKeys.shared.form.components.freeCheckedToggle.text}</Translate>
         }
         disabled={props.disabled}
         defaultValue={false}
      />
   );
};
